import MarkdownMessage from '../MarkdownMessage.jsx';
import { CopyButton } from './CouncilOutput.jsx';
import { deliberationToMarkdown, downloadCouncilMarkdown } from './councilExport.js';

export default function CouncilHistoryDetail({ detail, loading, onClose, onReuse }) {
  if (loading) return <p role="status">Carregando deliberação…</p>;
  if (!detail) return null;
  const markdown = deliberationToMarkdown(detail);
  return (
    <section aria-label="Deliberação salva" className="rounded-xl border border-apolo-borderSubtle bg-apolo-surface1 p-4">
      <div className="mb-4 flex flex-wrap items-center gap-3 text-sm text-apolo-textPrimary">
        <h2 className="mr-auto font-semibold">Deliberação salva</h2>
        <CopyButton text={markdown} label="Copiar histórico" />
        <button type="button" onClick={() => downloadCouncilMarkdown(markdown)}>Exportar histórico .md</button>
        <button type="button" onClick={() => onReuse(detail.id)}>Reutilizar questão</button>
        <button type="button" onClick={onClose}>Fechar deliberação</button>
      </div>
      <MarkdownMessage content={markdown} />
    </section>
  );
}
